import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';

const FormInputButton = props => {
  const { controlId, disabled = false, field = {}, value = '' } = props;

  const handleClick = event => {
    event.preventDefault();

    props.onClick && props.onClick(field.name);
  };

  const containerClass = classNames('button-container');

  let label = value || field.label;

  if (field.icon) {
    label = (
      <span className="button-icon">
        <i className={`zmdi zmdi-${field.icon}`} /> {label}
      </span>
    );
  }

  return (
    <div className={containerClass}>
      <Button onClick={handleClick} variant="secondary" disabled={disabled} id={`${controlId}-control`}>
        {label}
      </Button>
    </div>
  );
};

FormInputButton.propTypes = {
  controlId: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  field: PropTypes.object,
  onClick: PropTypes.func,
  value: PropTypes.string,
};

export default FormInputButton;
